<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1451_72)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM9.95996 8.13235C9.45529 7.62767 8.63704 7.62767 8.13236 8.13235C7.62769 8.63703 7.62769 9.45527 8.13236 9.95995L10.1724 12L8.13236 14.04C7.62769 14.5447 7.62769 15.363 8.13236 15.8676C8.63704 16.3723 9.45529 16.3723 9.95996 15.8676L12 13.8276L14.0401 15.8676C14.5447 16.3723 15.363 16.3723 15.8677 15.8676C16.3723 15.363 16.3723 14.5447 15.8677 14.04L13.8276 12L15.8677 9.95995C16.3723 9.45527 16.3723 8.63703 15.8677 8.13235C15.363 7.62767 14.5447 7.62767 14.0401 8.13235L12 10.1724L9.95996 8.13235Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_1451_72">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
